import React, { useState, useContext } from 'react';
import './ForgotPassword.css'
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import {useNavigate} from "react-router-dom";
import { authAPI } from '../../../api/authApi';
import {useTranslation} from "react-i18next";
import Button from '../../../components/UI/Button/Button';
import LanguageContext from '../../../context/LanguageContext';

export default function ForgotPassword() {
    const { dir } = useContext(LanguageContext);
    const { t, i18n } = useTranslation();
    const lang = i18n.language;

    const [error, setError] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const navigate = useNavigate();

    const validateEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    const [formData, setFormData] = useState({ email: '' });

    const handleEmailChange = (event) => {
        setFormData({ ...formData, email: event.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!validateEmail(formData.email)) {
            setError(t('forgotPasswordPage.invalidEmail'));
            return;
        }
        try {
            await authAPI.forgotPassword(formData);
            console.log(formData);

            setIsSubmitted(true);
        } catch (err) {
            setError(err.response?.data?.message || t('forgotPasswordPage.unexpectedError'));
        }
    };

    const reverseClass = dir() === 'rtl' ? 'reverse' : '';

    return (
        <main
            className='auth-main'
            lang={lang}
            dir={dir()}
        >
            <section className='section auth-public-section'>
                <div className="container forgot-password-container">
                    <div className="loginForm">
                        <button
                            onClick={() => navigate(`/${lang}/sign-in`)}
                            className="forgot-password-back-button"
                        >
                            <ArrowLeft size={16} />
                            {t('forgotPasswordPage.backToLogin')}
                        </button>

                        <div className="forgot-password-header">
                            <div className="forgot-password-icon-wrapper">
                                <Mail size={32} className="forgot-password-mail-icon" />
                            </div>
                            <h1 className="forgot-password-title">{t('forgotPasswordPage.resetPassword')}</h1>
                            <p className="forgot-password-subtitle">
                                {t('forgotPasswordPage.enterEmailSubtitle')}
                            </p>
                        </div>

                        {!isSubmitted ? (
                            <form onSubmit={handleSubmit} className="forgot-password-form-container">
                                <div className="forgot-password-input-group">
                                    <div className={`forgot-password-box ${reverseClass}`}>
                                        <Mail className="forgot-password-icon" />
                                        <div className="forgot-password-input-wrapper">
                                            <input
                                                type="email"
                                                value={formData.email}
                                                onChange={handleEmailChange}
                                                className="forgot-password-input"
                                                placeholder=" "
                                                required
                                            />
                                            <label className="forgot-password-label">
                                                {t('forgotPasswordPage.emailAddress')}
                                            </label>
                                        </div>
                                    </div>

                                    {error && <p className="forgot-password-error">{error}</p>}
                                </div>

                                <Button
                                    type="submit"
                                    className="forgot-password-submit-button"
                                >
                                    {t('forgotPasswordPage.sendResetLink')}
                                </Button>
                            </form>
                        ) : (
                            <div className="forgot-password-success-card">
                                <CheckCircle size={24} className="forgot-password-success-icon" />
                                <div className="forgot-password-success-content">
                                    <div className="forgot-password-success-title">{t('forgotPasswordPage.checkYourEmail')}</div>
                                    <div className="forgot-password-success-text">
                                        {t('forgotPasswordPage.successText', { email: formData.email })}
                                    </div>
                                </div>
                            </div>
                        )}

                        <p className="forgot-password-footer">
                            {isSubmitted ? (
                                <>
                                    <span className="forgot-password-footer-text">
                                        {t('forgotPasswordPage.didntReceiveEmail')} {' '}
                                    </span>
                                    <span
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setIsSubmitted(false);
                                            setFormData({ email: '' });
                                        }}
                                        className="forgot-password-login-link"
                                    >
                                        {t('forgotPasswordPage.tryAgain')}
                                    </span>
                                </>
                            ) : (
                                <>
                                    {t('forgotPasswordPage.rememberPassword')} {' '}
                                    <button onClick={()=> navigate(`/${lang}/sign-in`)} className="forgot-password-login-link">
                                        {t('forgotPasswordPage.signIn')}
                                    </button>
                                </>
                            )}
                        </p>
                    </div>
                </div>
            </section>
        </main>
    );
}
